.card {
  border: 1px solid light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-5));
}

.cardTitle {
  &::after {
    content: '';
    display: block;
    background-color: var(--mantine-color-blue-filled);
    width: 45px;
    height: 2px;
    margin-top: var(--mantine-spacing-sm);
  }
}